/** @module api/ems_variable_stores */

import { apiCall } from '@/api/index'
import {
  apiV1EnergyManagementSystemEmsVariableStoresPath,
  showApiV1EnergyManagementSystemEmsVariableStoresPath,
  updateApiV1EnergyManagementSystemEmsVariableStoresPath
} from '@/../lib/routes'

/**
 * GET a list of EMS Varible Stores.
 * Each store will only have `name` and `storeType`
 *
 * @function
 *
 * @param {object} params
 * @param {integer} params.emsId has to be the EMS-ID
 * @param {string} params.storeType is an optional filter by store type, e.g. `'USER'|'LIS'|'TECHNICIAN'`
 *
 * @return {promise}
 */
export function getEmsVariableStores({ ctxt = 'customer', emsId, storeType } = {}) {
  const payload = {}
  if (storeType) {
    payload.filter = {
      storeType
    }
  }

  return apiCall({
    path: apiV1EnergyManagementSystemEmsVariableStoresPath(ctxt, emsId),
    payload
  })
}

/**
 * GET an EMS Variable Store by name
 *
 * @function
 *
 * @param {object} params
 * @param {integer} params.emsId has to be the EMS-ID
 * @param {string} params.name has to be the EMS Variable-Store's name
 * @param {string} params.locale is optionally a locale/language (`'en'|'de'`)
 *
 * @return {Promise}
 */
export function getEmsVariableStore({ ctxt = 'customer', emsId, id, locale } = {}) {
  const payload = {
    id,
    locale
  }

  return apiCall({
    path: showApiV1EnergyManagementSystemEmsVariableStoresPath(ctxt, emsId),
    payload
  })
}

/**
 * PATCH an EMS Variable Store
 * Only `data` of the store can by updated.
 *
 * @function
 *
 * @param {object} params
 * @param {integer} params.emsId has to be the EMS-ID
 * @param {string} params.id has to be the store's ID
 * @param {object} params.data are the store's data to be updated.
 *
 * @return {Promise}
 */
export function updateEmsVariableStore({ ctxt = 'customer', emsId, id, data } = {}) {
  const payload = {
    data: {
      type: 'ems_variable_stores',
      id,
      attributes: {
        data
      }
    }
  }

  return apiCall({
    method: 'PATCH',
    path: updateApiV1EnergyManagementSystemEmsVariableStoresPath(ctxt, emsId),
    payload
  })
}
